  <div class="cardLayout">

    <ion-row class="col-md-reverse">
      <ion-col size="12" size-md class="phi-align-content-center">
        <div class="popup-heading">
          <p class="fs-16 fs_14ForMobile font_regular">360 degree created by HR ({{counterListData.length}})</p>
          <div class="mb-md-15">
            <!-- <label class="fs-16 fs_14ForMobile font_regular mr-15">Incomplete</label>
            <mat-slide-toggle class="toggle-element mr-10" [(ngModel)]="isToggleChecked" (change)="get360CounterPopUp()"></mat-slide-toggle>
            <label class="fs-16 fs_14ForMobile font_regular ml-15">Complete</label> -->
            <div class="mb-md-15">
              <label class="fs-16 font_regular mr-15">Incomplete</label>
              <mat-slide-toggle
                class="toggle-element mr-10"
                [(ngModel)]="isToggleChecked"
                (change)="toggleChanged()">
              </mat-slide-toggle>
              <label class="fs-16 font_regular ml-15">Complete</label>
            </div>
            
            
          </div>
        </div>
      </ion-col>
      <ion-col size="12" size-md="auto" class="phi-align-content-center">
        <div class="d-flex align-items-center justify-content-end" style="gap: 12px;">
          
          <!-- Refresh Icon -->
          <span class="fs-20 material-icons btn-reset cursor-pointer"
            [class.clicked]="isClicked"
            (click)="resetGrid(); isClicked = true"
            (animationend)="isClicked = false">
            refresh
          </span>
    
          <!-- Download Icon -->
          <span class="icon-download fs-20 material-icons cursor-pointer" style="cursor: pointer;"
            (click)="onBtExport('360_degree_created_by_HR')">
            download
          </span>
    
          <!-- Close Icon -->
          <span [mat-dialog-close]
            class="fs-30 fs_24ForMobile material-icons popup-close-icon cursor-pointer" style="cursor: pointer;">
            close
          </span>
    
        </div>
      </ion-col>
      <!-- <ion-col size="12" size-md="auto" class="phi-align-content-center">
        
        <div class="popup-close mb-md-15">
          <button class="download-btn" (click)="onClickDownloadScoresOfSurveys('360_degree_created_by_HR')">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            <span *ngIf="!mobileResponsiveService.hideForMobile">Download</span>
          </button>
          <span [mat-dialog-close] class="ml-35 ml-md-10 mr-5 fs-30 fs_24ForMobile material-icons popup-close-icon">close</span>
        </div>
      </ion-col> -->
    </ion-row>


    <!-- <ion-row>
      <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
        <p class="fs-16 fs_14ForMobile font_regular">360 degree created by HR ({{counterListData.length}})</p>
      </ion-col>
      <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
        <div>
  
          <label class="fs-14 fs_12ForMobile font_regular mr-15">Incomplete</label>
          <mat-slide-toggle class="toggle-element mr-20" [(ngModel)]="isToggleChecked" (change)="get360CounterPopUp()"></mat-slide-toggle>
          <label class="fs-14 fs_12ForMobile font_regular mr-15">Complete</label>

        </div>
      </ion-col>
      <ion-col size-sm="10" size-md="1" size-lg="1" size-xs="10">
        <button class="download-btn" (click)="onClickDownloadScoresOfSurveys('360_degree_created_by_HR')">
          <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
          <span *ngIf="!mobileResponsiveService.hideForMobile">Download</span>
        </button>
      </ion-col>
      <ion-col size-sm="2" size-md="1" size-lg="1" size-xs="2">
        <span [mat-dialog-close] class="ml-35 mr-5 fs-30 float-right material-icons popup-close-icon">close</span>  
      </ion-col>
    </ion-row> -->
  
    <ion-row>
 
      <ion-col size="12">
        <mat-sidenav-container style="height: 100%;">
          <!-- Main Content with AG Grid -->
          <mat-sidenav-content>
            <ag-grid-angular
            class="ag-theme-quartz"
            style="width: 100%; height: 400px;"
            [rowData]="counterListData"
            [columnDefs]="threeSixtyColumnDefs"
            [gridOptions]="gridOptions"
            [defaultColDef]="{ flex: 1, resizable: true, sortable: true, filter: true }"
            (rowClicked)="onRowClicked($event)"
            [pagination]="pagination"
            [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="paginationPageSizeSelector"
            [detailRowAutoHeight]="detailRowAutoHeight"
            [domLayout]="'autoHeight'"
            [localeText]="{ noRowsToShow: 'No Data Found' }"
            (gridReady)="onGridReady($event)">
          </ag-grid-angular>

          </mat-sidenav-content>
          <!-- Right Side Sidenav -->
          <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
            <!-- HEADER -->
             <div class="details-header">
              <h2>360 Degree Created By HR</h2>
              <button mat-icon-button (click)="closeDetails()">
                <mat-icon class="close-icon">close</mat-icon>
              </button>
            </div>
          <!-- <pre>{{threeSixtyColumnDefs |json}} </pre> -->
            <!-- CONTENT -->
            <div class="details-content" *ngIf="selectedRow">
              <mat-card class="detail-card" *ngFor="let col of threeSixtyColumnDefs">
                <mat-card-content  *ngIf="showColumn(col)">
                  <div class="detail-row">
                    <mat-icon class="detail-icon">trending_flat</mat-icon>
                    <div class="detail-text">
                      <span class="detail-label">{{ col.headerName }} </span>
            
               
                      <span *ngIf="col.field && selectedRow?.[col.field]">
                        {{
                          
                          col.field === 'startDate' || col.field === 'endDate'
                            ? formatDate(selectedRow[col.field])
                            : selectedRow[col.field]
                        }}
                      </span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            
            
            
          </mat-sidenav>
        </mat-sidenav-container>

        <!-- <div class="table-container">
         
          <table class="Market-correction-employees-table">
            <thead>
              <tr>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Name of 360 Review</th>
                <th>No. of self</th>
                <th>No. of peers</th>
                <th>No. of subordinates</th>
                <th>No. of superior</th>
                <th>No. of internal customer</th>
                <th>No. of external customer</th>
                <th>Total Employee</th>
                <th *ngIf="isToggleChecked">Completed</th>
                <th *ngIf="!isToggleChecked">Incompleted</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of counterListData">
                <td>{{item.startDate | date:'dd-MM-yyyy'}}</td>
                <td>{{item.endDate | date:'dd-MM-yyyy'}}</td>
                <td>{{item.reviewName}}</td>
                <td>{{item.noOfSelf}}</td>
                <td>{{item.noOfPeer}}</td>
                <td>{{item.noOfSubordinate}}</td>
                <td>{{item.noOfSuperior}}</td>
                <td>{{item.noOfInternalCustomer}}</td>
                <td>{{item.noOfExternalCustomer}}</td>
                <td>{{item.noOfTotalEmployee}}</td>
                <td *ngIf="isToggleChecked">{{item.noOfCompleted}}</td>
                <td *ngIf="!isToggleChecked">{{item.noOfIncompleted}}</td>
              </tr>
            </tbody>
          </table>
          
        </div> -->
      </ion-col>
    </ion-row>
  </div>
